// @ ACL Module Routes
export default [
    // ** Roles
    {
        path: "/profile/details",
        name: "profile.details",
        component: () => import("@/views/profile/Details.vue"),
        meta: {
            pageTitle: "Details",
            breadcrumb: [
                {
                    text: "Details",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },
    {
        path: "/profile/change-password",
        name: "profile.change-password",
        component: () => import("@/views/profile/ChangePassword.vue"),
        meta: {
            pageTitle: "Change Password",
            breadcrumb: [
                {
                    text: "Change Password",
                    active: true,
                },
            ],
            rule: "editor",
            requiresAuth: true,
        },
    },

];
